import { createTheme } from "@mui/material";

const theme = createTheme({
    typography: {
        fontFamily: `'Inter', sans-serif`
    },
    palette: {
        primary: {
            main: '#7F56D9',
        },
        secondary: {
            main: '#7F56D9',
        },
        checked: {
            main: '#7F56D9'
        }
    },
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#414651',
                }
            }
        },
    }
})

export default theme